/** Client logo rotation. Every mark is shown in solid white; slots draw from the whole pool. */
export interface ClientLogo {
  name: string;
  /** Image URL (PNG / SVG, or an inline SVG data URI) */
  src: string;
}

/** Inline SVG → data URI */
const svg = (viewBox: string, body: string) =>
  `data:image/svg+xml;utf8,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${viewBox}" fill="#fff">${body}</svg>`,
  )}`;
const word = (x: number, text: string, size = 30, weight = 700, spacing = -0.5) =>
  `<text x="${x}" y="32" font-family="Helvetica Neue, Arial, sans-serif" font-size="${size}" font-weight="${weight}" letter-spacing="${spacing}">${text}</text>`;

export const logoSets: ClientLogo[][] = [
  [
    // Neotix: rounded lowercase wordmark (redrawn — swap in the original file if you have it)
    { name: 'Neotix', src: svg('0 0 112 42', word(0, 'neotix', 34, 500, 0.5)) },
    { name: 'Playground Games', src: 'https://cdn.magicpatterns.com/uploads/bejxHhwCEkcH2VjHrRCEqt/6ade21fce2dc8606047e6cc4_Gruppe_9424.png' },
    { name: 'CyberX', src: 'https://cdn.magicpatterns.com/uploads/511LuoDvoSipxjHTfASwMa/6ade21fce2dc8606047e6cc3_Differenzmenge_153.png' },
    { name: 'Novastar', src: 'https://cdn.magicpatterns.com/uploads/7CQQJDFv5zDsjNrunMrTzy/6ade21fce2dc8606047e6cd0_Novastar.png' },
    { name: 'Supery', src: 'https://cdn.magicpatterns.com/uploads/rRNNevxMAGJmJmAGT94qy6/6ade21fce2dc8606047e6cd1_sup345745ery.png' },
  ],
  [
    { name: 'AIS', src: 'https://cdn.magicpatterns.com/uploads/1xd31Ngj9xQQqGjHTdVi15/6ade21fce2dc8606047e6ccd_Gruppe_maskieren_79.png' },
    { name: 'Oleven', src: 'https://cdn.magicpatterns.com/uploads/ftU8ZhE29VuWbLndLYUgHx/6ade21fce2dc8606047e6cc5_Gruppe_9426.png' },
    { name: 'Radical', src: 'https://cdn.magicpatterns.com/uploads/oPmb8mhHn8jkSbYyTFZd83/6ade21fce2dc8606047e6d04_Group_1000002791.svg' },
    { name: 'Fuel', src: 'https://cdn.magicpatterns.com/uploads/qCyiF4sUQCbdagnBWPDtKg/6ade21fce2dc8606047e6d01_Mask_group_(2).png' },
    { name: 'FNCE', src: 'https://cdn.magicpatterns.com/uploads/mj7jUdg4swLUQGpWvrE3zZ/6ade21fce2dc8606047e6d03_unnamed_1.png' },
  ],
  [
    // Invented marks
    // Halcyon: a sun setting into a line
    {
      name: 'Halcyon',
      src: svg('0 0 180 42', `<path d="M4 30a17 17 0 0 1 34 0z"/><rect x="0" y="33" width="42" height="4" rx="2"/>${word(52, 'halcyon', 30, 600, -0.5)}`),
    },
    // Monolith: a single tall slab + spaced caps
    {
      name: 'Monolith',
      src: svg('0 0 200 42', `<rect x="0" y="4" width="12" height="34" rx="1.5"/><rect x="16" y="14" width="6" height="24" rx="1.5"/>${word(32, 'MONOLITH', 26, 800, 3)}`),
    },
    // Kinetik: three sliding bars
    {
      name: 'Kinetik',
      src: svg('0 0 170 42', `<rect x="0" y="6" width="30" height="7" rx="3.5"/><rect x="8" y="17.5" width="30" height="7" rx="3.5"/><rect x="16" y="29" width="30" height="7" rx="3.5"/>${word(56, 'kinetik', 31, 800, -1)}`),
    },
    // Vanta: a sharp chevron V
    {
      name: 'Vanta',
      src: svg('0 0 150 42', `<path d="M0 4h11l10 22 10-22h11L21 40z"/>${word(50, 'VANTA', 28, 700, 2)}`),
    },
    // Orbital Labs: ring with a satellite dot
    {
      name: 'Orbital Labs',
      src: svg('0 0 205 42', `<path fill-rule="evenodd" d="M20 3a18 18 0 1 1 0 36a18 18 0 0 1 0-36zm0 7a11 11 0 1 0 0 22a11 11 0 0 0 0-22z"/><circle cx="35" cy="7" r="5"/>${word(50, 'orbital', 30, 700, -0.8)}${word(150, 'labs', 30, 300, -0.5)}`),
    },
  ],
];
